import { render, staticRenderFns } from "./tab-4-record-active.vue?vue&type=template&id=5e2ed1a0&scoped=true&lang=pug&"
import script from "./tab-4-record-active.vue?vue&type=script&lang=js&"
export * from "./tab-4-record-active.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ed1a0",
  null
  
)

export default component.exports